import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export const selectCalendarEvent = (state:RootState) => state.calendarEvents.event;
export const selectCalendarEvents = (state:RootState) => state.calendarEvents.events;
export const selectCalendarEventsParams = (state:RootState) => state.calendarEvents.params;
export const selectCurrentDate = (state:RootState) => state.calendarEvents.currentDate;
export const selectCurrentView = (state:RootState) => state.calendarEvents.currentView;

export const selectFullCalendarEvents = createSelector(
  [
    selectCalendarEvents,
    selectCurrentView
  ],
  (events, view) => {
    if (!events) return null;
    return events.map(event => ({
      id: event.id.toString(),
      title: view.startsWith('multiMonth') ? '' : event.title,
      start: event.start,
      end: event.end,
      description: event.description,
      location: event.location,
      allDay: view.startsWith('multiMonth') ? true : event.allDay,
      backgroundColor: event.type?.color ?? '#039be5',
      textColor: '#fff',
      display: view.startsWith('multiMonth') ? 'background' : 'auto',
    }));
  }
)

export const selectCalendarEventById = createSelector(
  [
    selectCalendarEvents,
    (_, props:{ eventId:number }) => props
  ],
  (events, { eventId }) => {
    if (!events) return null;
    const event = events.find(event => event.id === eventId);
    if (!event) return null;
    return event;
  }
)

export const selectCalendarEventByIds = createSelector(
  [
    selectCalendarEvents,
    (_, props:{ eventIds:number[] }) => props
  ],
  (events, { eventIds }) => {
    if (!events || !eventIds || eventIds.length === 0) return [];
    return events.filter(event => eventIds.includes(event.id));
  }
)
